/* MysticBluuMoon: Etsy-style prices in variant dropdowns.
   Matches each dropdown row by its visible option name and appends
   the variant's live price; shows sale price + strikethrough + %-off
   when a compare-at price exists. Single-option products only. */
(function () {
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  var buildPriceHtml = function (variant) {
    if (!variant) return '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
      return (
        '<span class="mbm-opt-price">' +
        '<strong>' + money(variant.price) + '</strong> ' +
        '<s style="opacity:0.6;">' + money(variant.compare_at_price) + '</s> ' +
        '<span style="color:#2e7d32;">(' + pct + '% off)</span>' +
        '</span>'
      );
    }
    return '<span class="mbm-opt-price"><strong>' + money(variant.price) + '</strong></span>';
  };

  var decorate = function (picker, product) {
    if (product.options.length !== 1) return;
    var byName = {};
    product.variants.forEach(function (v) { byName[v.option1] = v; });

    // Custom popover dropdown rows: match by visible option name
    picker.querySelectorAll('.popover__value-option').forEach(function (label) {
      if (label.hasAttribute('data-mbm-priced')) return;
      if (!label.querySelector('input[type="radio"]')) return;
      var name = label.textContent.trim();
      var variant = byName[name];
      if (!variant) return;
      label.insertAdjacentHTML('beforeend', buildPriceHtml(variant));
      label.setAttribute('data-mbm-priced', '');
    });

    // Native select fallback
    picker.querySelectorAll('select option').forEach(function (opt) {
      if (opt.hasAttribute('data-mbm-priced')) return;
      var variant = byName[opt.textContent.trim()];
      if (!variant) return;
      var txt = ' \u2014 ' + money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        txt = ' \u2014 ' + money(variant.price) + ' (' + pct + '% off, was ' + money(variant.compare_at_price) + ')';
      }
      opt.textContent = opt.textContent.trim() + txt;
      opt.setAttribute('data-mbm-priced', '');
    });
  };

  var init = function () {
    document.querySelectorAll('variant-picker[handle]').forEach(function (picker) {
      var handle = picker.getAttribute('handle');
      if (!handle) return;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          decorate(picker, product);
          new MutationObserver(function () { decorate(picker, product); })
            .observe(picker, { childList: true, subtree: true });
        })
        .catch(function () { /* leave dropdown as-is on fetch failure */ });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
